import script from "./SocialFundRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundRequests.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundRequests.vue?vue&type=style&index=0&id=83e0a8ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83e0a8ec"]])

export default __exports__